import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './PrivateRoute.css';

/* ─────────────────────────────────────────────────────────────
   PrivateRoute
───────────────────────────────────────────────────────────── */
const PrivateRoute = ({ children }) => {
  const { user, isAuthenticated, loading, authError, retryAuth, hasActiveSubscription } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-gate-loading">
        <div className="auth-gate-loading-title">Loading...</div>
        <div className="auth-gate-loading-sub">Checking authentication...</div>
      </div>
    );
  }

  if (authError) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center', padding: '40px 20px', backgroundColor: 'var(--danger-soft)', border: '1px solid rgba(220, 38, 38, 0.2)' }}>
        <h2 style={{ color: 'var(--danger)', marginBottom: '16px' }}>Authentication Error</h2>
        <p style={{ color: 'var(--danger-hover)', marginBottom: '24px', maxWidth: '400px' }}>{authError}</p>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <button onClick={retryAuth} style={{ backgroundColor: 'var(--primary-color)', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '6px', fontSize: '16px', cursor: 'pointer' }}>
            Retry Authentication
          </button>
          <button onClick={() => window.location.href = '/login'} style={{ backgroundColor: 'var(--danger)', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '6px', fontSize: '16px', cursor: 'pointer' }}>
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Super admins use the admin area, not the customer app (unless viewing as a customer)
  if (user?.role === 'super_admin' && !user.impersonating) {
    return <Navigate to="/admin" replace />;
  }

  // No active subscription — send to billing page
  if (!hasActiveSubscription && location.pathname !== '/billing') {
    return <Navigate to="/billing" replace />;
  }

  return children;
};

export default PrivateRoute;
